import { createClient } from '@connectrpc/connect';
import { createConnectTransport } from '@connectrpc/connect-web';
import { MetricService } from '@buf/alconostmt_services.bufbuild_es/alconost/mt/metric_pb.js';

const transport = createConnectTransport({
    baseUrl: 'https://services-375925469890.us-central1.run.app',
});

const client = createClient(MetricService, transport);

export const createMetric = async (id, name, email) => {
    try {
        const request = {
            id: id,
            name: name || '',
            email: email || ''
        };
        const response = await client.createMetric(request);
        console.log('CreateMetric response:', response);
        return response;
    } catch (error) {
        console.error('Error creating metric:', error);
        throw error;
    }
};

export const getMetric = async (id) => {
    try {
        const request = {
            id: id
        };
        const response = await client.getMetric(request);
        console.log('GetMetric response:', response);
        return response;
    } catch (error) {
        console.error('Error getting metric:', error);
        throw error;
    }
};

export const getMetricItems = async (metricId, pageSize = 100, pageNumber = 0) => {
    try {
        const request = {
            metricId: metricId,
            pageSize: pageSize,
            pageNumber: pageNumber
        };
        const response = await client.getMetricItems(request);
        console.log("getMetricItems response:", response);
        return response;
    } catch (error) {
        console.error('Error getting metric items:', error);
        throw error;
    }
};

export const updateMetric = async (metricId, field, value) => {
    try {
        const request = {
            metricId: metricId,
            field: {
                value: value,
                case: field
            }
        };

        console.log('UpdateMetric request:', request);
        const response = await client.updateMetric(request);
        return response;
    } catch (error) {
        console.error('Error updating metric:', error);
        throw error;
    }
};


export const addMetricItems = async (metricId, items) => {
    try {
        const request = {
            metricId: metricId,
            items: items
        };
        console.log('AddMetricItems request:', request);
        const response = await client.addMetricItems(request);
        return response;
    } catch (error) {
        console.error('Error adding metric items:', error);
        throw error;
    }
};

export const updateMetricItems = async (metricId, items) => {
    try {
        const request = {
            metricId: metricId,
            items: items
        };
        console.log('UpdateMetricItems request:', request);
        const response = await client.updateMetricItems(request);
        return response;
    } catch (error) {
        console.error('Error updating metric items:', error);
        throw error;
    }
};

export const processMetric = async (metricId) => {
    try {
        const request = {
            metricId: metricId
        };
        console.log('ProcessMetric request:', request);
        const response = await client.processMetric(request);
        return response;
    } catch (error) {
        console.error('Error processing metric:', error);
        throw error;
    }
};

export const getMetricProcessingStatus = async (metricIds = []) => {
    try {
        const request = {
            metricIds: metricIds
        };
        const response = await client.getMetricProcessingStatus(request);
        console.log('GetMetricProcessingStatus response:', response);
        return response;
    } catch (error) {
        console.error('Error getting metric processing status:', error);
        throw error;
    }
};

export const estimateMetric = async (metricId) => {
    try {
        const request = {
            metricId: metricId
        };
        const response = await client.estimateMetric(request);
        console.log('EstimateMetric response:', response);
        return response;
    } catch (error) {
        console.error('Error estimating metric:', error);
        throw error;
    }
};
